import React, { useState } from "react"
import ReactMarkdown from "react-markdown"
import { graphql } from "gatsby"
import Layout from "../components/_App/layout"
import Seo from "../components/_App/seo"
import Navbar from "../components/_App/Navbar"
import PageBanner from "../components/Common/PageBanner"
import Footer from "../components/_App/Footer"
//import { Link } from "gatsby"
import * as Icon from "react-feather"
import { Lightbox } from "react-modal-image"


const BlogDetailsPage = ({ data }) => {
  const [urlToTinyImageFile, seturlToTinyImageFile] = useState(null)
 // const [urlToHugeImageFile, seturlToHugeImageFile] = useState(null)
  const [closeLightbox, setcloseLightbox] = useState(false)

  console.log(data)
  const {
    title,
    image,
    date,
    author,
    blogDetails,
    tags,
    blogImage
  } = data.blog

  return (
    <Layout>
      <Navbar />

      <PageBanner pageTitle={title} />
      <div className="blog-details-area ptb-80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-6 mx-auto" >
              <div className="article-image">
                <img
                  //src={image.url}
                  style={{ maxHeight: "450px" }}
                  src={`${'https://cmsscience.nustwebsite.com'}${image.url}`}
                  alt={"team.image.alternativeText"} />
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-lg-10 col-md-12">
              <div className="blog-details-desc">

                <div className="article-content mb-4">


                  <ReactMarkdown>{blogDetails.data.blogDetails}</ReactMarkdown>
                </div>
                {<div className="container">

                  <div className="row">
                    {blogImage &&
                      blogImage.map((image, index) => (
                        <div className='col-lg-4 col-md-12 mb-4 mb-lg-0' 
                        key={index}
                        >
                          <img
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              console.log(`${image.url}`)
                              setcloseLightbox(true)
                              seturlToTinyImageFile(`${'https://cmsscience.nustwebsite.com'}${image.url}`)
                              //seturlToHugeImageFile(`${'https://cmsscience.nustwebsite.com'}${image.url}`)
                            }}
                            src={`${'https://cmsscience.nustwebsite.com'}${image.url}`}
                            className={index % 2 === 0 ? "w-100 mb-2 mb-md-4 shadow-1-strong rounded" : 'w-100 shadow-1-strong rounded mb-4'}
                            alt={"image"} />
                        </div>
                      ))
                    }
                  </div>
                </div>}


                <div className="article-content mb-4">
                  <div className="entry-meta">
                    <ul>
                      <li>
                        <Icon.Clock /> {date}
                      </li>
                      <li>
                        <Icon.User /> {author}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/*<div className="col-lg-4 col-md-12">
              
              <BlogSidebar />
            </div>*/}
          </div>
        </div>
      </div>
      {closeLightbox && <Lightbox
        medium={urlToTinyImageFile}
      //  large={urlToHugeImageFile}
        
        alt="image"
        onClose={()=>setcloseLightbox(false)}
      />}
      <Footer />
    </Layout>
  )
}

export const query = graphql`
  query GetSingleBlog($slug: String, $language: String!) {
    blog: strapiBlog(slug: { eq: $slug }) {
      title
      image {
        url
        
      }
      blogImage {
        url
        id
      }
      title
      date(formatString: "MMMM Do, YYYY")
      author
      blogDetails {
        data {
          blogDetails
        }
      }
      tags {
        id
        text
        slug
      }
    }
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }

`

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo title="News Details" />

export default BlogDetailsPage
